import { createAsyncThunk } from "@reduxjs/toolkit";
import { UserAPIService } from "src/constants";
import { sendRequestJSON } from "src/lib/axios";
import { toastMessage } from "../commonSlice";
import { IUserForm } from "src/pages/user/type";

export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async (_, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        null,
        UserAPIService.GET_USER_LIST,
        "get"
      );
      if (!response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const fetchUserById = createAsyncThunk(
  "users/fetchUserById",
  async (userId:string, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        null,
        `${UserAPIService.GET_USER}/${userId}`,
        "get"
      );
      if (!response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const fetchRoles = createAsyncThunk(
  "users/fetchRoles",
  async (_, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        null,
        UserAPIService.GET_ROLE_LIST,
        "get"
      );
      if (!response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const createUser = createAsyncThunk(
  "users/createUser",
  async (user: IUserForm, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        user,
        UserAPIService.CREATE_USER,
        "post"
      );
      if (response.error) {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
      } else {
        dispatch(
          toastMessage({
            message: response.result.data.message,
          })
        );
      }
      return response.result.data;
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return false;
    }
  }
)

export const updateUser = createAsyncThunk(
  "users/updateUser",
  async (user: IUserForm, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        user,
        UserAPIService.UPDATE_USER,
        "put"
      );
      if (response.error) {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
      } else {
        dispatch(
          toastMessage({
            message: response.result.data.message,
          })
        );
      }
      return response.result.data;
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return false;
    }
  }
)

export const updateUserStatus = createAsyncThunk(
  "users/updateUserStatus",
  async (user: any, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        user,
        UserAPIService.UPDATE_USER_STATUS,
        "put"
      );
      if (response.error) {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
      } else {
        dispatch(
          toastMessage({
            message: response.result.data.message,
          })
        );
      }
      return response.result.data;
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return false;
    }
  }
)